import React, {useState} from "react";
import {Box, Button, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CreateProductDialog from "./CreateProductDialog";
import ResponseDialog from "../ResponseDialog";
import AdminShop from "./AdminShop";
import CreateSizeDialog from "./CreateSizeDialog";
import {COUNTRIES} from "../../constants";

const MenuProps = {
    PaperProps: {
        sx: {
            maxWidth: "fit-content"
        },
    },
};

export default function ProductControl() {

    const getLocationsArray=() => {
        let array = [];
        array[0] = "-";
        COUNTRIES.forEach(item => {
            array.push(item)
        })
        return array;
    }

    const [state, setState] = useState({
        isResponseDialogOpen: false,
        responseData: {
            isUpdate: false,
            responseData: {}
        },
        isProductDialogOpen : false,
        isSizeDialogOpen : false,
        isCreateSizeButtonClick: false,
        locationFilter: "",
        locations: getLocationsArray()
    });



    const handleClose = (responseData) => {
        setState({
            ...state,
            isResponseDialogOpen: responseData.isResponseReady,
            responseData: responseData.data,
            isProductDialogOpen: false
        })
    };
    const handleCreateProduct = () => {
        setState({
            ...state,
            isCreateSizeButtonClick: false,
            isProductDialogOpen: true
        })
    }
    const handleResponseDialogClose= () => {
        setState({
            ...state,
            isResponseDialogOpen: false
        })
    }
    const handleCreateSize = () => {
        setState({
            ...state,
            isCreateSizeButtonClick: true,
            isSizeDialogOpen : true
        })
    }
    const handleCloseCreateSize = (isResponseReady, responseData) => {
        setState({
            ...state,
            isResponseDialogOpen: isResponseReady,
            responseData: responseData,
            isSizeDialogOpen : false
        })
    }
    const handleLocationFilterChange = (event) => {
        setState({
            ...state,
            locationFilter: event.target.value
        })
    }

    return (
        <Box>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap'}}>
                <Button
                    color="warning"
                    size="small"
                    onClick={handleCreateProduct}
                    variant={'contained'}
                    startIcon={<AddIcon/>}
                >
                    Create product
                </Button>
                <Button
                    color="warning"
                    size="small"
                    variant="outlined"
                    onClick={handleCreateSize}
                >
                    Add size
                </Button>
                <FormControl className="control__location navbar__location"
                             size="small"
                             sx={{ml: 'auto', minWidth: 200}}>
                    <InputLabel
                        color="warning"
                        id="location-select-label">
                        Filter by location
                    </InputLabel>

                    <Select
                        color="warning"
                        labelId="location-select-label"
                        id="location-select"
                        value={state.locationFilter ? state.locationFilter : ''}
                        label="Filter by location"
                        onChange={handleLocationFilterChange}
                        MenuProps={MenuProps}
                        sx={{
                            borderRadius: '20px',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderRadius: '20px',
                            }
                        }}
                    >
                        {state.locations.map((option, index) => (
                            <MenuItem key={`location_select_image_${index}`}
                                      value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            <CreateProductDialog
                open={state.isProductDialogOpen}
                onClose={handleClose}
                isCopyMode={false}
                isEditMode={false}
            />
            <CreateSizeDialog
                open={state.isSizeDialogOpen}
                onClose={handleCloseCreateSize}
            />
            {state.responseData &&
                <ResponseDialog
                    onClose={handleResponseDialogClose}
                    open={state.isResponseDialogOpen}
                    responseData={state.isCreateSizeButtonClick ? state.responseData :
                        state.responseData.responseData ? state.responseData.responseData : {}}
                    label={state.isCreateSizeButtonClick ? "Size creation" :
                        state.responseData.isUpdate ? "Product update" : "Product creation"}
                />
            }

            <AdminShop locationFilter = {state.locationFilter !== "-" ? state.locationFilter : "" }/>
        </Box>
    );
}
